import { parseResidencePeriodToMonths } from "@/features/learning-progress/schema/learnerReportFilterSchema";

export type TLearnerReportFilterForm = {
  fullName: string;
  nationalityIds: string[];
  genders: string[]; // "1" | "2" | "3"
  prefectures: string[];
  residencePeriodMonthsFrom: string;
  residencePeriodMonthsTo: string;
};

export const defaultLearnerReportFilterValues: TLearnerReportFilterForm = {
  fullName: "",
  nationalityIds: [],
  genders: [],
  prefectures: [],
  residencePeriodMonthsFrom: "",
  residencePeriodMonthsTo: "",
};

export const isEmptyLearnerReportFilterValue = (value: unknown): boolean => {
  if (Array.isArray(value)) return value.length === 0;
  return value === "" || value == null;
};

// from/to レンジと各 multi-select はそれぞれ 1 件としてカウント。
export const countActiveLearnerReportFilters = (filters: TLearnerReportFilterForm | null): number => {
  if (!filters) return 0;
  let count = 0;
  if (filters.fullName) count += 1;
  if (filters.nationalityIds?.length > 0) count += 1;
  if (filters.genders?.length > 0) count += 1;
  if (filters.prefectures?.length > 0) count += 1;
  if ((filters.residencePeriodMonthsFrom ?? "") !== "" || (filters.residencePeriodMonthsTo ?? "") !== "") count += 1;
  return count;
};

export type TLearnerReportFilterApiParams = {
  fullName?: string;
  nationalityIds?: number[];
  genders?: number[];
  prefectures?: string[];
  residencePeriodMonthsFrom?: number;
  residencePeriodMonthsTo?: number;
};

export const buildLearnerReportFilterApiParams = (filters: TLearnerReportFilterForm | null): TLearnerReportFilterApiParams => {
  if (!filters) return {};
  const params: TLearnerReportFilterApiParams = {};
  if (filters.fullName && filters.fullName.trim()) params.fullName = filters.fullName.trim();
  if (filters.nationalityIds && filters.nationalityIds.length > 0) params.nationalityIds = filters.nationalityIds.map(Number).filter(Number.isFinite);
  if (filters.genders && filters.genders.length > 0) params.genders = filters.genders.map(Number).filter(Number.isFinite);
  if (filters.prefectures && filters.prefectures.length > 0) params.prefectures = filters.prefectures;
  const fromMonths = parseResidencePeriodToMonths(filters.residencePeriodMonthsFrom ?? "");
  const toMonths = parseResidencePeriodToMonths(filters.residencePeriodMonthsTo ?? "");
  if (typeof fromMonths === "number") params.residencePeriodMonthsFrom = fromMonths;
  if (typeof toMonths === "number") params.residencePeriodMonthsTo = toMonths;
  return params;
};
